import React, { useState } from 'react';

const SEC_03_RoleManagementView = ({ roles = [], loading, onUpdate, onAdd }) => {
    const [newRow, setNewRow] = useState({
        roleCode: '',
        roleName: '',
        isActive: true
    });

    const handleAddSubmit = () => {
        onAdd(newRow);
        setNewRow({ roleCode: '', roleName: '', isActive: true });
    };

    if (loading) return <div className="p-4 small text-muted italic">Loading Roles List...</div>;

    return (
        <div className="table-responsive">
            <table className="table table-hover align-middle">
                <thead className="table-light">
                    <tr>
                        <th>Role Code</th>
                        <th>Role Name</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {/* 1. Empty State Handling */}
                    {roles.length === 0 ? (
                        <tr>
                            <td colSpan="4" className="text-center text-muted fst-italic py-3">
                                No roles available. Please add one below.
                            </td>
                        </tr>
                    ) : (
                        /* 2. Map the existing flat list */
                        roles.map((role, index) => (
                            <tr key={role.roleCode || index}>
                                <td className="fw-bold">{role.roleCode}</td>
                                <td>{role.roleName}</td>
                                <td>{role.isActive ? "Displayed" : "Hidden"}</td>
                                <td>
                                    <button 
                                        className={`btn btn-sm fw-bold ${role.isActive ? 'btn-outline-secondary' : 'btn-outline-primary'}`}
                                        onClick={() => onUpdate(role.roleCode, { isActive: !role.isActive })}
                                        title={role.isActive ? "Hide this role" : "Display this role"}
                                    >
                                        {role.isActive ? "Hide" : "Display"}
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}

                    {/* 3. The persistent "Add New" row at the bottom */}
                    <tr className="bg-light">
                        <td>
                            <input 
                                type="text" 
                                className="form-control form-control-sm" 
                                placeholder="e.g. AUDITOR" 
                                value={newRow.roleCode}
                                onChange={(e) => setNewRow({ ...newRow, roleCode: e.target.value.toUpperCase() })}
                            />
                        </td>
                        <td>
                            <input 
                                type="text" 
                                className="form-control form-control-sm" 
                                placeholder="Role Name" 
                                value={newRow.roleName}
                                onChange={(e) => setNewRow({ ...newRow, roleName: e.target.value })}
                            />
                        </td>
                        <td>
                            <span className="badge bg-success">Displayed</span>
                        </td>
                        <td>
                            <button 
                                className="btn btn-sm btn-outline-secondary fw-bold" 
                                onClick={handleAddSubmit}
                                title="Add Role"
                            >
                                ➕
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default SEC_03_RoleManagementView;